// Configuration
window.icons = [];
export default {
  config: {
    iconSize: 115,
    gapHorizontal: 40,
    gapVertical: 100,
    longPressDuration: 1500,
    scrollHoverDuration: 1000
  },
  currentLayout: null,  // ADD THIS LINE
  currentScreen: 0,
  currentFolderScreen: 0,
  openFolder: null,
  isDraggingIcon: false,  // Export this so render can check it
  dragState: null,
  isDraggingScreen: false,
  longPressTimer: null,
  scrollHoverTimer: null,
  folderCloseTimer: null, 
  editingIcon: null,
  dragGhost: null,
  temporaryScreenSide: null, // 'left' or 'right' when temporary screen exists
  isInteractingWithIcon: false,
  intendedDropAction: null, // Stores what drop should do
  iconPressStart: null, // Add at module level
  isProcessingDrop: false, // CRITICAL: Prevents duplicate folder creation
  folderDragState: {
    startX: 0,
    currentX: 0,
    isDragging: false,
    startScreen: 0
  },
  setDraggingState: function(dragging) {
    this.isDraggingIcon = dragging;
    if (dragging) {
        document.body.classList.add('dragging-icon');
    } else {
        document.body.classList.remove('dragging-icon');
    }
  },
  clearAllTimers: function() {
      if (this.longPressTimer) {
          clearTimeout(this.longPressTimer);
          this.longPressTimer = null;
      }
      if (this.scrollHoverTimer) {
          clearTimeout(this.scrollHoverTimer);
          this.scrollHoverTimer = null;
      }
      if (this.folderCloseTimer) {
          clearTimeout(this.folderCloseTimer);
          this.folderCloseTimer = null;
      }
      if (this.autoScrollInterval) {
          clearInterval(this.autoScrollInterval);
          this.autoScrollInterval = null;
      }
  }
};
